// extracted by mini-css-extract-plugin
module.exports = {"root":"Ribbon_root__1aR58","pcf":"Ribbon_pcf__FHvgl","pcfError":"Ribbon_pcfError__vEF4D"};